import SelectComponent from "../../ui/select/SelectComponent";
import * as React from "react";
import User from "../../../model/user/User";

export default class SelectUsers extends SelectComponent<User> {
	matchFilter(element: User, filter: string): boolean {
		return element.searchString.indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: User): string {
		return element.id;
	}

	elementToString(element: User) {
		return element.getDisplayName(true);
	}

	onInputChange(value: string){
		this.props.onInputChange(value);
	}
}
